import { gql } from '@apollo/client';

export const FETCH_MANAGE_STAFF_PAGE = gql`
  query FetchManageStaffPage {
    manageUsersPage {
      data {
        attributes {
          title
          description
          staffListTitle
          staffEmptyState {
            title
            description
          }
          staffStatus {
            pendingInviteMessage
            invitedPendingSignUpMessage
            registeredPendingOnboardingMessage
            registeredOnboardedMessage
            invitedPendingSignUpColor
            registeredPendingOnboardingColor
            registeredOnboardedColor
            pendingInviteColor
          }
        }
      }
    }
  }
`;
